import { expose } from 'comlink';
import { collection, getDocs, getFirestore, query, Query } from 'firebase/firestore';
import { AbstractWarehouseSyncStepWorker } from './abstract-warehouse-worker.utils';
import { WarehouseSyncStepTaskContext } from '../executors';
import type { ProgressCallback } from '../executors';
import { WarehouseOutlineSegment } from '../../warehouse/warehouse.dto';
import { OUTLINE_COLLECTION, OUTLINES_STORE, WW_WAREHOUSES_COLLECTION, logger } from '@damofire/data-commons';

export class WarehouseOutlinesStepsWorker extends AbstractWarehouseSyncStepWorker {
  constructor() {
    super(OUTLINES_STORE, 'OUTLINES');
  }

  protected async clean(ctx: WarehouseSyncStepTaskContext, onProgress?: (progress: number) => void): Promise<void> {
    logger.debug('WarehouseOutlinesStepsWorker::clean', { division: ctx.division, category: 'sync' });
    return this.deleteAllDataObsoleteFromStore<WarehouseOutlineSegment>(this.store, ctx, (dto) => dto.divisionId, undefined, onProgress);
  }

  protected async download(ctx: WarehouseSyncStepTaskContext, onProgress?: ProgressCallback): Promise<void> {
    logger.debug('WarehouseOutlinesStepsWorker::download', { division: ctx.division, category: 'sync' });

    const q: Query = query(collection(getFirestore(), `${WW_WAREHOUSES_COLLECTION}/${ctx.division}/${OUTLINE_COLLECTION}`));
    const outlines = await getDocs(q).then((docs) =>
      docs.docs.map((d) => ({
        ...d.data(),
        divisionId: ctx.division,
        division: {
          _id: ctx.division,
        },
        _id: d.id,
        syncId: ctx.syncId,
      })),
    );

    logger.info('Downloaded outlines from Firestore', { count: outlines.length, category: 'sync' });

    if (!this.shouldStopTask) {
      await this.idbService.updateAll(this.store, outlines).catch(console.error);
      onProgress?.(100, { processed: outlines.length, expected: outlines.length });
    }
  }
}

expose(WarehouseOutlinesStepsWorker);
